import React from "react";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
import { RCCInput, RCCHookToast, RCCButton, RCCServicesApi, RCCGrid } from "react-common-components";
import { useForm } from "react-hook-form";
import {getValidationErrors, standardErrorMessages} from "src/utils/errors";
import { useTranslation } from "src/context/Translations/context";
import LoginScreen from "src/components/LoginScreen";
import { IPageLoginFormSubmit } from "./interface";

const ForgotPassword: React.FC = () => {
	const { translate } = useTranslation();
	const { register, setError, clearErrors, handleSubmit, formState: { errors } } = useForm();
	const { addToast } = RCCHookToast();
	const history = useHistory();

	const submitForm = async (data: IPageLoginFormSubmit) :Promise<void> => {
		try
		{
			clearErrors();

			const schema = Yup.object().shape({
				email: Yup.string().email().required(translate("Email é obrigatório"))
			});

			await schema.validate(data, {
				abortEarly: false
			});

			await RCCServicesApi.postRequest({
				method: "UserPublic/ForgotPassword",
				body: {
					email: data.email
				}
			});

			addToast({
				title: translate("Sucesso"),
				description: translate("E-mail de recuperação de senha enviado"),
				color: "green"
			});

			history.push("/login");
		}
		catch(err)
		{
			if(getValidationErrors(err, setError))
				return;

			standardErrorMessages(err, translate("Verifique os campos e tente novamente"), addToast);
		}
	};

	return (
		<LoginScreen contentPosition="start">
			<form onSubmit={handleSubmit(submitForm)}>
				<h1>{translate("Recuperar senha")}</h1>
				<RCCInput 
					name="email"
					type="email" 
					label={translate("Email")}
					register={register} 
					error={errors.email}
					layout="outlined"
					autoComplete="off"
					icon={{
						name: "user",
						color: "var(--purple-lighter)"
					}}
				/>
				<br />
				<RCCButton 
					color="purple" 
					type="submit" 
					styleInline={`
								padding: 24px;
								width: 100%;
								>span.span-of-component-button{
									font-size: 1rem;
									font-weight: bold;
								}	
							`}
				>
					{translate("Recuperar senha")}
				</RCCButton>
				<br />
				<RCCGrid container item justifyContent="center">
					<Link to="/login">{translate("Voltar")}</Link>
				</RCCGrid>
			</form>

		</LoginScreen>
	);
};

export default ForgotPassword;
